﻿import React from 'react';
import GradientBarHorizontal from './GradientBarHorizontal';
import GradientBarVertical from './GradientBarVertical';
import { BarOrientation } from './types';
import { GradientPalette } from '@fe/weather';

function GradientBar({ data, orientation }: { data: GradientPalette; orientation: BarOrientation }) {
    return orientation === BarOrientation.Horizontal ? <GradientBarHorizontal data={data} /> : <GradientBarVertical data={data} />;
}

export default GradientBar;
